import { banksListDeserializer } from 'pages/bank-account/components/bank-account-form/schema';
import { banksJson, defaultAccountTypes, defaultPlaceholders } from 'utils/banks/banks';

const useBanksList = (list = null) => {
  const banks = list || banksJson.banks;
  const optionsBank = banks.map(banksListDeserializer);

  return {
    banks,
    defaultAccountTypes,
    defaultPlaceholders,
    optionsBank,
  };
};

export default useBanksList;
